module.exports = __webpack_public_path__ + "media/images/new-ui-images/blue-dollar-4ed719240d39b28b9240c69e24935580.svg";